/*
 * Supported app languages: English, Spanish and Brazilian Portuguese (owner decision, 2026-10-05: German, Polish and
 * European Portuguese were removed). The language pill, the marketing site and the sign-up flow all offer this list.
 * The organization's EMAIL language is a separate backend setting (`Organization::SUPPORTED_LOCALES`); see lib/registrationLocale.ts.
 */

export interface SupportedLanguage {
  code: string;
  name: string;
  flag: string;
}

const LANGUAGES: Record<string, SupportedLanguage> = {
  en: { code: 'en', name: 'English', flag: '🇺🇸' },
  es: { code: 'es', name: 'Español', flag: '🇲🇽' },
  'pt-BR': { code: 'pt-BR', name: 'Português (BR)', flag: '🇧🇷' },
};

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [LANGUAGES.en, LANGUAGES.es, LANGUAGES['pt-BR']];

/** Kept for the callers that name the marketing site's list: it is the same list. */
export const MARKETING_LANGUAGES: SupportedLanguage[] = SUPPORTED_LANGUAGES;

/**
 * The entry of `languages` for an i18next language code: an exact match first, then the same
 * base language (a browser's "es-MX" shows Spanish, "pt" shows Brazilian Portuguese), then the
 * first entry.
 */
export function findLanguage(languages: SupportedLanguage[], code: string | undefined): SupportedLanguage {
  const exact = languages.find((lang) => lang.code === code);
  if (exact) return exact;
  const base = (code || '').split('-')[0].toLowerCase();
  return languages.find((lang) => lang.code.split('-')[0].toLowerCase() === base) || languages[0];
}
